import React, { Component, ReactNode, CSSProperties } from 'react';
import './MeterSelectBar.scss';

interface MeterSelectBarProps {
  selected?: boolean;
  number: number;
  onSelect?: () => void;
  className?: string;
  style?: CSSProperties;
}

export class MeterSelectBar extends Component<MeterSelectBarProps> {
  handleClick = (): void => {
    if (this.props.onSelect) {
      this.props.onSelect();
    }
  };

  render(): ReactNode {
    const { selected, className, style, number } = this.props;
    const selectedClass = `${selected ? 'meter-select-bar--selected' : ''}`;
    const fullClassName = `meter-select-bar ${selectedClass} ${className ? className : ''}`;
    return (
      <button className={fullClassName} onClick={this.handleClick} style={style}>
        <div className="meter-select-bar__background" />
        <div className="meter-select-bar__number">{number}</div>
      </button>
    );
  }
}
